import { useState, useEffect } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token") || localStorage.getItem("adminToken");
const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");
const fmtDate = d => {
  if (!d) return "�";
  try { return new Date((d.includes("+")||d.includes("Z"))?d:d+"+03:00").toLocaleString("en-KE",{timeZone:"Africa/Nairobi",day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit",second:"2-digit"}); }
  catch(e){ return d; }
};

export default function Transactions() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("ALL");
  const [search, setSearch] = useState("");

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(BASE+"/admin/activity", { headers:{ Authorization:"Bearer "+tok() } });
      if (r.ok) setRows(await r.json());
    } catch(e) {}
    setLoading(false);
  };

  const types = ["ALL","LOGIN_SUCCESS","LOGIN_FAILED","STK_SENT","FEE_PAID","PAYMENT_FAILED","DISBURSED"];

  const filtered = rows.filter(r => {
    const matchType = filter === "ALL" || r.eventType === filter;
    const q = search.toLowerCase();
    const matchSearch = !q ||
      (r.userName||"").toLowerCase().includes(q) ||
      (r.userEmail||"").toLowerCase().includes(q) ||
      (r.phone||"").includes(q) ||
      (r.detail||"").toLowerCase().includes(q) ||
      String(r.applicationId||"").includes(q);
    return matchType && matchSearch;
  });

  const statusColor = s => ({
    LOGIN_SUCCESS:"#10b981", LOGIN_FAILED:"#ef4444",
    STK_SENT:"#7c3aed", FEE_PAID:"#0066cc",
    PAYMENT_FAILED:"#ef4444", DISBURSED:"#10b981",
    SUCCESS:"#10b981", FAILED:"#ef4444", PENDING:"#f59e0b"
  }[s]||"#94a3b8");

  return (
    <div style={{fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>

      {/* Filter bar */}
      <div style={{background:"white",borderRadius:10,padding:"12px 14px",marginBottom:14,display:"flex",gap:6,flexWrap:"wrap",alignItems:"center",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
        {types.map(t=>(
          <button key={t} onClick={()=>setFilter(t)}
            style={{padding:"6px 12px",borderRadius:20,border:"none",cursor:"pointer",fontSize:11,fontWeight:600,
              background:filter===t?statusColor(t)||"#0052a3":"#f1f5f9",
              color:filter===t?"white":"#64748b",
              whiteSpace:"nowrap"}}>
            {t.replace(/_/g," ")} {t!=="ALL"&&`(${rows.filter(r=>r.eventType===t).length})`}
          </button>
        ))}
        <div style={{marginLeft:"auto",position:"relative"}}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)"}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..."
            style={{padding:"7px 10px 7px 26px",border:"1px solid #e2e8f0",borderRadius:7,fontSize:12,width:180}}/>
        </div>
        <button onClick={load} style={{padding:"7px 12px",borderRadius:7,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:"#f1f5f9",color:"#64748b",display:"flex",alignItems:"center",gap:5}}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
          Refresh
        </button>
      </div>

      {/* Table */}
      <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 6px rgba(0,0,0,0.06)",overflow:"hidden"}}>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #f1f5f9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h3 style={{fontSize:14,fontWeight:700,color:"#1e293b",margin:0}}>Transaction Log</h3>
          <span style={{fontSize:12,color:"#94a3b8"}}>{filtered.length} records</span>
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead>
              <tr style={{background:"#f8fafc"}}>
                {["id","event_type","user_name","user_email","phone","detail","amount","application_id","status","created_at"].map(h=>(
                  <th key={h} style={{padding:"10px 12px",textAlign:"left",fontWeight:700,color:"#64748b",fontSize:10,textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap",borderBottom:"1px solid #e2e8f0"}}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} style={{padding:48,textAlign:"center",color:"#94a3b8"}}>Loading...</td></tr>
              ) : filtered.length===0 ? (
                <tr><td colSpan={10} style={{padding:48,textAlign:"center",color:"#94a3b8"}}>No records found</td></tr>
              ) : filtered.map((r,i)=>(
                <tr key={r.id||i} style={{borderTop:"1px solid #f1f5f9",background:r.eventType==="LOGIN_FAILED"||r.eventType==="PAYMENT_FAILED"?"#fff5f5":r.eventType==="FEE_PAID"||r.eventType==="DISBURSED"?"#f0fdf4":i%2?"#fafafa":"white"}}>
                  <td style={{padding:"9px 12px",color:"#94a3b8",fontSize:12,fontFamily:"monospace"}}>{r.id}</td>
                  <td style={{padding:"9px 12px"}}>
                    <span style={{background:statusColor(r.eventType)+"18",color:statusColor(r.eventType),borderRadius:4,padding:"3px 8px",fontSize:11,fontWeight:700,whiteSpace:"nowrap",fontFamily:"monospace"}}>
                      {r.eventType||"�"}
                    </span>
                  </td>
                  <td style={{padding:"9px 12px",fontWeight:600,color:"#1e293b",whiteSpace:"nowrap"}}>{r.userName||"NULL"}</td>
                  <td style={{padding:"9px 12px",color:"#64748b",fontSize:12}}>{r.userEmail||"NULL"}</td>
                  <td style={{padding:"9px 12px",fontFamily:"monospace",color:"#334155",whiteSpace:"nowrap"}}>{r.phone||"NULL"}</td>
                  <td style={{padding:"9px 12px",color:"#64748b",fontSize:12,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.detail||"NULL"}</td>
                  <td style={{padding:"9px 12px",fontWeight:r.amount?700:400,color:r.amount?"#059669":"#94a3b8",whiteSpace:"nowrap"}}>{r.amount?fmt(r.amount):"NULL"}</td>
                  <td style={{padding:"9px 12px",color:"#0066cc",fontWeight:r.applicationId?700:400,fontFamily:"monospace"}}>{r.applicationId?"APP-"+r.applicationId:"NULL"}</td>
                  <td style={{padding:"9px 12px"}}>
                    <span style={{background:statusColor(r.status)+"18",color:statusColor(r.status),borderRadius:4,padding:"3px 8px",fontSize:11,fontWeight:700,fontFamily:"monospace"}}>
                      {r.status||"NULL"}
                    </span>
                  </td>
                  <td style={{padding:"9px 12px",color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{fmtDate(r.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
